import { CardLayout, ReviewCard } from '../../../sdk/@types/Revisao';

export type CardTipoMostrado = 'Oclusão' | 'Memorizar' | 'Texto';

/**
 * A derivação única do tipo mostrado do cartão (design, Decisão 9 de
 * flashcards-revisao-redesign). A lista administrativa e a fila da sessão chamam
 * esta função em vez de comparar `layout` por conta própria, para que as duas
 * telas não possam rotular o mesmo cartão de formas diferentes.
 *
 * "Imagem" e "Lista" são formas de autorar um cartão `basic` no compositor — esse
 * é um dialeto à parte (NovoCartao.view.tsx) e não entra nesta derivação.
 */
export function cardTipoMostrado(card: Pick<ReviewCard, 'layout'>): CardTipoMostrado {
  const layout: CardLayout | undefined = card.layout;
  if (layout === 'occlusion') return 'Oclusão';
  if (layout === 'single') return 'Memorizar';
  return 'Texto';
}
